import { Tag } from "lucide-react";
import {
  AppliedCoupon,
  PricingBreakdown,
  Subscription,
} from "../../types/plans";
import { formatCurrency } from "../../constants";

interface AppliedCouponDisplayProps {
  appliedCoupon: AppliedCoupon;
  pricingBreakdown: PricingBreakdown | null;
  selectedPlan: Subscription;
}

export function AppliedCouponDisplay({
  appliedCoupon,
  pricingBreakdown,
  selectedPlan,
}: AppliedCouponDisplayProps) {
  const currency = selectedPlan.price.currency;

  return (
    <div className="alert alert-success border-success-subtle">
      <div className="d-flex align-items-center gap-2 mb-2">
        <span className="fw-medium text-success-emphasis">
          {appliedCoupon.code} Applied!
        </span>
        {appliedCoupon.description && (
          <span className="small text-success-emphasis">
            ({appliedCoupon.description})
          </span>
        )}
      </div>
      <div className="small text-success-emphasis">
        {appliedCoupon.type === "percentage" ? (
          <span>{appliedCoupon.discountValue}% discount applied</span>
        ) : (
          <span>
            {formatCurrency(appliedCoupon.discountValue, currency)} discount
            applied
          </span>
        )}
        {pricingBreakdown && (
          <span>
            {" "}
            • You saved{" "}
            {formatCurrency(pricingBreakdown.couponDiscount, currency)}!
          </span>
        )}
      </div>
    </div>
  );
}
